export default __webpack_public_path__ + "static/media/1-stepRes.94dde1b8.png";